var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column flex-root"},[_c('div',{staticClass:"d-flex flex-row-fluid bgi-size-cover bgi-position-center",style:({
            backgroundImage: `url(${_vm.backgroundImage})`
        })},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row-fluid flex-column justify-content-end align-items-center text-center text-white pb-40"},[_c('h1',{staticClass:"display-1 font-weight-bold"},[_vm._v(" OOPS! ")]),_c('span',{staticClass:"display-4 font-weight-boldest mb-8"},[_vm._v(" Something went wrong here ")])])
}]

export { render, staticRenderFns }